import { createProviderToken } from '@core/common-legacy';

export interface AuthModuleTranslations {
  authenticationForm: {
    emailVerificationCode: string;
    usePassword: string;
    resendCode: string;
    currentPassword: string;
    placeholder: string;
    useVerificationCode: string;
    authentication: string;
    toContinueVerify: string;
    ssoEnabledInfobox: string;
  };
  adminPasswordForm: {
    changePassword: string;
    newPassword: string;
    yourPassword: string;
    currentPassword: string;
    currentPasswordPlaceholder: string;
    oneNumber: string;
    passwordLength: string;
    useLowerUpper: string;
    confirmNewPassword: string;
    title: string;
  };
  common: {
    or: string;
    cancel: string;
    continue: string;
    goBack: string;
  };
  dialog_2fa_app: {
    step_1: {
      header: string;
      header_step: string;
      header_description: string;
      description: string;
      picture_alt: string;
    };
    step_2: {
      header: string;
      header_step: string;
      header_description: string;
      infobox: string;
      code_header: string;
      manual_code: string;
      cta: string;
    };
  };
  dialog_2fa_sms: {
    number_required: string;
    number_length: string;
    number_invalid: string;
    success_toast: {
      title: string;
      message: string;
    };
    step_1: {
      header: string;
      header_step: string;
      header_description: string;
      phone: string;
      phone_placeholder: string;
      phone_description: string;
      number_is_invalid: string;
      infobox_title: string;
      infobox_description: string;
      security_link: string;
    };
    step_2: {
      header: string;
      header_step: string;
      header_description: string;

      resend: string;
      code_sent: string;
      activation_code: string;
      warning_title: string;
      warning_description: string;
      security_link: string;
      set_up_now: string;
    };
  };
}

export const { provide: provideAuthTranslations, inject: injectAuthTranslations } =
  createProviderToken<AuthModuleTranslations>('AuthModuleTranslations')(false);
